import React from "react";
import { Instagram } from "lucide-react";
import { SectionHeading } from "@/components/PackSelection";

const IG_URL = "https://instagram.com/ozentya_pousse_cheveux";
const TIKTOK_URL = "https://www.tiktok.com/@ozentyapoussecheveu";

const IMAGES = [
  "https://images.unsplash.com/photo-1535588706069-af8f2d837332?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxoZWFsdGh5JTIwbmF0dXJhbCUyMGhhaXIlMjBiZWF1dHklMjB3b21hbnxlbnwwfHx8fDE3OTA3MjQxMjd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1505330375570-be7ea15a6ce9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwbmF0dXJhbCUyMGhhaXIlMjBiZWF1dHklMjB3b21hbnxlbnwwfHx8fDE3OTA3MjQxMjd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1632765854612-9b02b6ec2b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwbmF0dXJhbCUyMGhhaXIlMjBiZWF1dHklMjB3b21hbnxlbnwwfHx8fDE3OTA3MjQxMjd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1593351799227-75df2026356b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwbmF0dXJhbCUyMGhhaXIlMjBiZWF1dHklMjB3b21hbnxlbnwwfHx8fDE3OTA3MjQxMjd8MA&ixlib=rb-4.1.0&q=85",
];

export const InstagramFeed = () => (
  <section className="bg-[var(--oz-bg-2)]">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
      <SectionHeading eyebrow="Communauté" title="Rejoignez-nous sur Instagram" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
        {IMAGES.map((src, i) => (
          <a
            key={i}
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`instagram-tile-${i}`}
            className="group relative aspect-square rounded-2xl overflow-hidden"
          >
            <img src={src} alt="Ozentya sur Instagram" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute inset-0 bg-[var(--oz-dark)]/0 group-hover:bg-[var(--oz-dark)]/40 transition-colors flex items-center justify-center">
              <Instagram className="w-7 h-7 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </a>
        ))}
      </div>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <a
          href={IG_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[var(--oz-dark)] text-white font-semibold text-sm hover:bg-black transition-colors"
        >
          <Instagram className="w-4 h-4" /> Suivre @ozentya_pousse_cheveux
        </a>
        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="tiktok-follow"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-[var(--oz-dark)] text-[var(--oz-dark)] font-semibold text-sm hover:bg-[var(--oz-dark)] hover:text-white transition-colors"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true"><path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.5c-1.2.1-2.4-.2-3.5-.8v6.2c0 3.2-2.4 5.7-5.6 5.7-3 0-5.4-2.3-5.4-5.3 0-3.1 2.6-5.5 5.9-5.1v2.6c-.4-.1-.8-.2-1.2-.2-1.5 0-2.6 1.2-2.6 2.7 0 1.5 1.1 2.6 2.6 2.6 1.6 0 2.7-1.1 2.7-3V3h3.1z"/></svg>
          Suivre sur TikTok
        </a>
      </div>
    </div>
  </section>
);
